export default {
  DATE: 'date',
  SELECT: 'select',
  SELECT_V2: 'selectV2',
};
